import { useRef } from "react";

/**
 * A new record's uuid, chosen here and kept for every try of the same create (sent with it: a retry after a timeout updates the
 * record ServiceM8 may already have made, not a second one), then a fresh one once it's made (`made`), for the next.
 */
export function useNewUuid() {
    const uuid = useRef<string | null>(null);
    return {
        get: () => (uuid.current ??= crypto.randomUUID()),
        made: () => {
            uuid.current = null;
        },
    };
}
